import {createFileRoute} from '@tanstack/react-router';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {ModelSettings} from '~components/models/settings/ModelSettings';
import {AdvancedConfigurationProvider} from 'src/contexts/AdvancedConfigurationContext';
import {ModelProvider} from 'src/contexts/ModelProvider';

export const Route = createFileRoute('/model/settings')({
  component: ModelSettingsPage,
});

function ModelSettingsPage(): JSX.Element {
  return (
    <ModelProvider mode='model-pages'>
      <AdvancedConfigurationProvider>
        <BaseLayout showBackButton customContentAndFooter>
          <ModelSettings />
        </BaseLayout>
      </AdvancedConfigurationProvider>
    </ModelProvider>
  );
}
